import { IAutomationObject } from '../../types'

export interface IControlled2Point extends IAutomationObject {
    valueOn: number;
    valueOff: number;
    setpoint: number;
    hysteresis: number;
    on: boolean;
}


export const schema = 'AutomationApps.Functions.Controllers.Controlled2Point';


